import {rackSlots} from './lab-rack';
import {surface,type LabItem} from './mini-lab-mechanics';

export function LabTubeDrawing({item,paint,color='#b9dce1'}:{item:LabItem;paint:(name:string)=>string;color?:string}){
 if(item.kind==='test-tube-rack')return <g>
  <path d="M-83-74V2M83-74V2" stroke="#7897a1" strokeWidth="6"/>
  <path d="M-89-72H89V-60H-89ZM-89-10H89V1H-89Z" fill={paint('case')} stroke="#7f9da6"/>
  {rackSlots.map((x,i)=><g key={x}><ellipse cx={x} cy="-69" rx="13" ry="4" fill="#6d8994" stroke="#d9e9e2"/><text x={x} y="15" textAnchor="middle" fontSize="11" fill="#426775">{i+1}</text></g>)}
 </g>;
 const path='M-13-151H13V-15Q13 3 0 3Q-13 3-13-15Z',level=surface(item)-item.y;
 return <g>
  <g>
  <defs><clipPath id={paint('tube-inside').slice(5,-1)}><path d="M-11-150H11V-15Q11 1 0 1Q-11 1-11-15Z"/></clipPath></defs>
  <path d={path} fill={paint('glass')} stroke="#7698a7" strokeWidth=".9"/>
  {item.volume>0&&<g clipPath={paint('tube-inside')}><path d={`M-12 ${level}H12V4H-12Z`} fill={paint('liquid')}/><ellipse cy={level} rx="11" ry="2.4" fill={color} fillOpacity=".6" stroke="#edf9f1" strokeWidth=".7"/></g>}
  <path d="M-9-143V-17Q-9-7-5-5" stroke="#f5fff5" strokeWidth="1.8" fill="none"/>
  <ellipse cy="-151" rx="13" ry="3" fill="none" stroke="#88a8b5"/>
  </g>
  <text y="-163" textAnchor="middle" fontSize="10" fill="#385d6c">{item.volume.toLocaleString('fr-FR',{maximumFractionDigits:1})} mL</text>
 </g>;
}
